import { h, Component } from 'preact';
import cx from 'classnames';

import { Listing } from '../../../../types/listing.model';

export const RANK_BY_VIEWS = 'rank-by-views';
export const RANK_BY_INQUIRIES = 'rank-by-inquiries';

interface PopularByInquiriesProps {
  locations: string[];
  isComingSoon?: boolean;
}

interface PopularByInquiriesState {
  isCollapseVisible?: boolean;
}

export class PopularByInquiries extends Component<PopularByInquiriesProps, PopularByInquiriesState> {
  constructor(props: PopularByInquiriesProps) {
    super(props);

    // this.setState({
    //   listings: props.listings
    // });
  }

  toggleCollapsable = () => {
    this.setState({
      isCollapseVisible: !this.state.isCollapseVisible
    });
  }

  getDataHeadersBlock(props: PopularByInquiriesProps, state: PopularByInquiriesState) {
    return (
      <div className="col-12 d-flex ">
        <div className="hi-popular-by-inquiries__listings__header location">
          Location
        </div>
        <div className="hi-popular-by-inquiries__listings__header">
          Inquiries
        </div>
      </div>
    );
  }

  getDataColumnsBlock(props: PopularByInquiriesProps, location: string) {
    return (
      <div className="col-12 hi-popular-by-inquiries__listing">
        <p className="hi-popular-by-inquiries__listing__location">
          { location }
        </p>
        <p className="hi-popular-by-inquiries__listing__inquiry-counts">
          {Math.floor(Math.random() * 1000)}
        </p>
      </div>
    );
  }

  getComingSoonBlock(props: PopularByInquiriesProps) {
    if (props.isComingSoon) {
      return (
        <div className="hi-data-display-widget__coming-soon">
          <h4 className="hi-data-display-widget__coming-soon__h4">
            Coming soon
          </h4>
        </div>
      );
    }
  }

  render(props: PopularByInquiriesProps, state: PopularByInquiriesState) {
    return (
      <div className="hi-popular-by-inquiries hi-widget-collapsable">
        <div className="row hi-widget-collapsable__toggle-row">
          { this.getComingSoonBlock(props) }
          <div className="col-10">
            <h4 className="hi-popular-by-inquiries__name">
              Popular Locations by Inquiries
            </h4>
          </div>
          <div className="col-2 d-md-none">
            <i className={ cx('fas fa-chevron-down', {
                'visible': state.isCollapseVisible
              })}
              onClick={ this.toggleCollapsable }>
            </i>
          </div>
        </div>
        <div className={ cx('hi-widget-collapsable__body', {
          'visible': state.isCollapseVisible
        }) }>
          <div className="row">
            <div className="col-12">
              <p className="hi-popular-by-inquiries__desc">
               (Across Kumita) January 2019 - October 2019
              </p>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12">
              <button className="btn hi-popular-by-inquiries__cat-toggle active">
                Rental
              </button>
              <button className="btn hi-popular-by-inquiries__cat-toggle">
                Sale
              </button>
            </div>
          </div>

          <div className="row hi-popular-by-inquiries__listings mt-4">
            {
              this.getDataHeadersBlock(props, state)
            }
            {
              props.locations.map((location, index) => {
                return this.getDataColumnsBlock(props, location);
              })
            }
          </div>
        
        </div>
      </div>
    );
  }
}